import { Component, Input, OnInit } from '@angular/core';
import { IPageDataViewModel } from '../pages';

@Component({
  selector: 'app-page-data-table',
  templateUrl: './page-data-table.component.html',
  styleUrls: ['./page-data-table.component.scss']
})
export class PageDataTableComponent implements OnInit {

  constructor() { }

  @Input() vm: IPageDataViewModel;
  @Input() title: string = undefined;
  @Input() subTitle: string = undefined;
  @Input() headingSize: number = 1;
  @Input() mobileModeTitleCol: number = -1;

  headingSize1: boolean = true;
  headingSize2: boolean = false;
  headingSize3: boolean = false;
  headingSize4: boolean = false;
  headingSize5: boolean = false;

  ngOnInit() {
    this.headingSize1 = this.headingSize == 1;
    this.headingSize2 = this.headingSize == 2;
    this.headingSize3 = this.headingSize == 3;
    this.headingSize4 = this.headingSize == 4;
    this.headingSize5 = this.headingSize == 5;
  }

}
